var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#333",
    cx: 10,
    cy: 10,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.005 5.969a1 1 0 0 1 1.327-.078l.088.078 2.553 2.554L12.53 5.97a1 1 0 0 1 1.492 1.327l-.078.087-2.556 2.555 2.556 2.554a1 1 0 0 1-1.327 1.492l-.087-.078-2.556-2.554-2.553 2.554a1 1 0 0 1-1.492-1.327l.077-.087L8.56 9.938 6.005 7.383a1 1 0 0 1 0-1.414z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0ee9ad81ec1d2f79d967553efce77c66.svg";
export { ForwardRef as ReactComponent };